import circle from "./circle.svg";
export default circle;

export const logo = require("./logo1.png");
export const about1 = require("./about01.png");
export const about2 = require("./about02.png");
export const about3 = require("./about03.png");
export const about4 = require("./about04.png");
export const adidas = require("./adidas.png");
export const amazon = require("./amazon.png");
export const api = require("./api.png");
export const asus = require("./asus.png");
export const bgImg = require("./bgIMG.png");
export const bgWhite = require("./bgWhite.png");
export const bolt = require("./bolt.png");

export const cpp = require("./cpp.png");
export const css = require("./css.png");
export const emailImg = require("./email.png");
export const flutter = require("./flutter.png");
export const figma = require("./figma.png");
export const git = require("./git.png");
export const graphql = require("./graphql.png");
export const html = require("./html.png");
export const javascript = require("./javascript.png");
export const mobile = require("./mobile.png");
export const mu5 = require("./mu5.png");
export const np = require("./nb.png");
export const node = require("./node.png");
export const profile = require("./profile.png");
export const profile2 = require("./profile2.png");
export const python = require("./python.png");
export const react = require("./react.png");
export const redux = require("./redux.png");
export const sass = require("./sass.png");
export const skype = require("./skype.png");
export const spotify = require("./spotify.png");
export const typescript = require("./typescript.png");
export const vue = require("./vue.png");
export const cv = require("./cv.pdf");
export const cv2 = require("./cv2.pdf");
